// Hindi of src/content/legal/refunds.ts. Keep keys and structure in step with the English.
import { COMPANY } from '../company';
import type { LegalDoc } from './types';

export const REFUNDS_HI: LegalDoc = {
  title: 'रिफ़ंड नीति',
  summary: 'अगर किसी भुगतान या रिपोर्ट में कुछ गड़बड़ हो जाए, तो हमें बताएँ और हम उसे ठीक करेंगे।',
  updated: '28 September 2026',
  sections: [
    {
      id: 'full-refund',
      heading: 'पूरा रिफ़ंड',
      blocks: [
        'यह हिंदी अनुवाद आपकी सुविधा के लिए है। किसी भी अंतर की स्थिति में अंग्रेज़ी संस्करण मान्य होगा।',
        'अगर रिपोर्ट डाउनलोड नहीं हुई या आप तक नहीं पहुँची, या एक ही रिपोर्ट के लिए आपसे एक से ज़्यादा बार पैसे लिए गए, तो हम भुगतान के 7 दिन के भीतर पूरा रिफ़ंड करते हैं।',
      ],
    },
    {
      id: 'duplicate-charges',
      heading: 'दोहरा चार्ज',
      blocks: ['अगर कोई दोहरा चार्ज दिखे, तो हमसे संपर्क करें और हम उसे रिफ़ंड कर देंगे। हम हर दोहरे चार्ज की जाँच अपनी ओर की गड़बड़ी मानकर भी करते हैं।'],
    },
    {
      id: 'after-delivery',
      heading: 'रिपोर्ट मिल जाने के बाद',
      blocks: [
        'क्योंकि रिपोर्ट एक डिजिटल प्रोडक्ट है जो ख़ास तौर पर आपके बच्चे के लिए तैयार की जाती है, इसलिए रिपोर्ट मिल जाने के बाद हम आमतौर पर रिफ़ंड नहीं करते। अगर आपकी रिपोर्ट में कुछ गड़बड़ हुई है, तो हमें बताएँ, हम उसे दोबारा जारी करेंगे, या अपने विवेक से रिफ़ंड करेंगे।',
      ],
    },
    {
      id: 'nurture-plus',
      heading: 'Nurture Plus',
      blocks: [
        'आप Nurture Plus को कभी भी सेटिंग्स में रद्द कर सकते हैं। रद्द करने से अगला चार्ज रुक जाता है; मौजूदा तिमाही का रिफ़ंड नहीं होता, और तिमाही ख़त्म होने तक उसके अनलॉक आपके पास रहते हैं।',
      ],
    },
    {
      id: 'how-to-ask',
      heading: 'कैसे माँगें',
      blocks: [
        `अपनी रिपोर्ट के रेफ़रेंस के साथ [${COMPANY.supportEmail}](mailto:${COMPANY.supportEmail}) पर ईमेल करें। रिफ़ंड उसी तरीक़े में वापस जाता है जिससे मूल भुगतान किया गया था, आमतौर पर 5 से 7 कार्य दिवसों के भीतर, और रिफ़ंड जारी होते ही रिपोर्ट फिर से लॉक हो जाती है।`,
      ],
    },
  ],
};
